export const PageHeader = ({ overline, title, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4">
    <div>
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">{overline}</p>
      <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 mt-1" data-testid="page-title">
        {title}
      </h1>
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);
